<div class="card-deck">
    <h4>{{ListHeader}}</h4>
    <div class="containerCard">
      <div *ngFor="let item of items;let i = index" class="box" (click)="onClickItem(item.ID,i)">
            <img [src]="item.image">
            <p class="text-nowrap">{{item.name}}</p>
      </div>
    </div>

</div>

